// extracted by mini-css-extract-plugin
module.exports = {"summary-wrapper":"_2v9ixgfEHehSqF_G0IhoQ-","preLoaderShimmer":"_2wA4xTuzJH7966DPg-THdR"};